/** Oylik maqsad halqasi hisobi (test: math.test.ts): ulush, sur'at bo'yicha kutilgan son, farq, qolgan. */
export interface GoalData {
  hired: number;
  goal: number;
  per_recruiter: number;
  recruiters: number;
  day: number;
  days: number;
  bonus_per_hire: number;
  bonus_currency: string;
}

export function goalStats(d: Pick<GoalData, "hired" | "goal" | "day" | "days">) {
  const pct = d.goal > 0 ? Math.min(d.hired / d.goal, 1) : 0;
  const pace = d.goal > 0 ? Math.round((d.goal * d.day) / d.days) : 0;
  return { pct, pace, diff: d.hired - pace, remaining: Math.max(d.goal - d.hired, 0), reached: d.goal > 0 && d.hired >= d.goal };
}
